import classNames from 'clsx';
import React, { useContext } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import { select } from '@swf/core/store';

import BackIcon from '../../../assets/back.svg';
import CreateTournamentContext from '../../CreateTournamentContext/CreateTournamentContext';

import { TXTCLI_Advanced, TXTCLI_Back, TXTMOB_Create } from './Buttons.messages.json';
import { advanced, back, buttonContainer, create, embeddedContainer, hidden } from './Buttons.scss';

const Buttons: React.FC = () => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const {
    state: { loading, isAdvancedOptionsOpen, isRecurrenceOpen },
    setState
  } = useContext(CreateTournamentContext);

  const { getState, submit } = useForm();
  const { valid } = getState();

  return (
    <div
      className={classNames(buttonContainer, {
        [hidden]: isRecurrenceOpen,
        [embeddedContainer]: isEmbedded
      })}
    >
      {isAdvancedOptionsOpen ? (
        <StarsButton
          type="button"
          variant="text"
          className={back}
          onClick={() => setState((prevState) => ({ ...prevState, isAdvancedOptionsOpen: false }))}
          translation={TXTCLI_Back}
          icon={<BackIcon />}
        />
      ) : (
        <StarsButton
          type="button"
          id="advancedOptions"
          className={advanced}
          onClick={() => setState((prevState) => ({ ...prevState, isAdvancedOptionsOpen: true }))}
          translation={TXTCLI_Advanced}
          variant="text"
        />
      )}
      <StarsButton
        type="submit"
        className={create}
        translation={TXTMOB_Create}
        disabled={loading || !valid}
        onClick={submit}
      />
    </div>
  );
};

export default Buttons;
